import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { CopySource } from 'app/model/pipeline/copysource/copysource';

export class GenericCopySourceAdapter extends CopySourceAdapter<CopySource, Model.CopySource> {
    protected override async _toResource(copySource: CopySource): Promise<Model.CopySource> {
        const sourceType = Metamodel.modelOf(copySource).name;
        return this.getCommonCopySourceProperties(copySource, sourceType);
    }

    protected override async _toModel(copySource: Model.CopySource, copyActivity: CopyActivity): Promise<CopySource> {
        const model = Metamodel.modelByName(copySource.type);
        return this.createCopySourceWithCommonProperties(model, copySource, copyActivity);
    }
}
